import { AxiosInstance } from "axios";
import { OrganizationPublicId, UUIDString } from "../Types";
import { ApiRouteHelpers } from "../../../root/apiRoutes";
import { RoPADetailsDto, RoPASummaryDto } from "../dto/RoPADto";

export class RoPAController {
  constructor(private axios: AxiosInstance) {}

  public getRoPASummary = async (organizationId: OrganizationPublicId): Promise<RoPASummaryDto> => {
    const url = ApiRouteHelpers.organization.documents.ropa.summary(organizationId);
    const response = await this.axios.get<RoPASummaryDto>(url);
    return response.data as RoPASummaryDto;
  };

  public getRoPAHistory = async (
    organizationId: OrganizationPublicId,
  ): Promise<RoPASummaryDto[]> => {
    const url = ApiRouteHelpers.organization.documents.ropa.history(organizationId);
    const response = await this.axios.get<RoPASummaryDto[]>(url);
    return response.data as RoPASummaryDto[];
  };

  public deleteRoPA = async (
    organizationId: OrganizationPublicId,
    ropaId: UUIDString,
  ): Promise<void> => {
    const url = ApiRouteHelpers.organization.documents.ropa.delete(organizationId, ropaId);
    const response = await this.axios.delete(url);
    return response.data.success;
  };

  public saveLatestRoPA = async (organizationId: OrganizationPublicId): Promise<boolean> => {
    const url = ApiRouteHelpers.organization.documents.ropa.saveLatestVersion(organizationId);
    const response = await this.axios.post<{ success: boolean }>(url);
    return response.data.success;
  };

  public setMeasures = async (
    organizationId: OrganizationPublicId,
    measuresMarkup: string,
  ): Promise<boolean> => {
    const url = ApiRouteHelpers.organization.documents.ropa.setMeasures(organizationId);
    const response = await this.axios.post(url, { measures: measuresMarkup });
    return response.data.success;
  };

  public getRoPADetails = async (organizationId: OrganizationPublicId): Promise<RoPADetailsDto> => {
    const url = ApiRouteHelpers.organization.documents.ropa.details(organizationId);
    const response = await this.axios.get<RoPADetailsDto>(url);
    return response.data as RoPADetailsDto;
  };
}
